var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4805 23.2134L21.2527 17.9855C21.0167 17.7496 20.6969 17.6185 20.3613 17.6185H19.5066C20.9538 15.7675 21.8137 13.4393 21.8137 10.9067C21.8137 4.88179 16.9319 0 10.9071 0C4.88216 0 0.000366211 4.88179 0.000366211 10.9067C0.000366211 16.9316 4.88216 21.8134 10.9071 21.8134C13.4397 21.8134 15.7679 20.9534 17.6189 19.5062V20.3609C17.6189 20.6965 17.75 21.0163 17.9859 21.2523L23.2138 26.4802C23.7067 26.9731 24.5037 26.9731 24.9914 26.4802L26.4753 24.9962C26.9682 24.5033 26.9682 23.7063 26.4805 23.2134ZM10.9071 17.6185C7.19983 17.6185 4.19525 14.6192 4.19525 10.9067C4.19525 7.19946 7.19458 4.19488 10.9071 4.19488C14.6143 4.19488 17.6189 7.19422 17.6189 10.9067C17.6189 14.6139 14.6195 17.6185 10.9071 17.6185Z",
    fill: "#41197F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon2);
export default __webpack_public_path__ + "static/media/searchIcon2.224a1840f7d2f848c0e45ae8f41563d7.svg";
export { ForwardRef as ReactComponent };